
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage } from 'element-plus';
import router from '@/router';
import UpdatePasswordModel from '@/models/userInfos/updatePasswordModel';
import UserInfoService from '@/services/userInfoService';
import CurrentUserService from '@/services/currentUserService';
import ErrorCode from '../constants/ErrorCode';
import CommonValidate from '../services/commonValidate';

export default class Login extends Vue {
private updateForm=new UpdatePasswordModel();

private readonly userInfo = CurrentUserService.GetUserInfo();

private checkPass = (rule:any, value:any, callback:any) => {
  if (value !== this.updateForm.newPassword) {
    callback(new Error('两次输入密码不一致'));
  } else {
    callback();
  }
};

private rules= {
  oldPassword: [
    { required: true, message: '请输入当前密码', trigger: 'blur' },
  ],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { validator: CommonValidate.validatePass, trigger: 'blur' },
  ],
  checkPassword: [
    { required: true, message: '请再次输入密码', trigger: 'blur' },
    { validator: this.checkPass, trigger: 'blur' },
  ],
};

back(): void {
  router.push('/');
}

save():void {
  const form:any = this.$refs.formLabelAlign;
  form.validate((valid:boolean) => {
    if (valid) {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const result = UserInfoService.updatePassword(this.updateForm);
      result.then((p) => {
        loadingInstance.close();
        if (p.code === ErrorCode.Success) {
          ElMessage.success(p.msg);
          form.resetFields();
        } else {
          ElMessage.error(p.msg);
        }
      }).catch((error) => {
        loadingInstance.close();
        console.info(error);
        ElMessage.error('未知错误');
      });
    }
  });
}
}
